export default "__VITE_ASSET__Dq687APa__"